import React, { memo } from 'react'

import { buildProviderImageProps } from '../../../util/pointsExchange.helpers'
import ProviderIcon from './ProviderIcon'

const ExchangeProviderIcon = ({
  provider,
  isForceBrandIcon = false,
  iconSize = 128,
  fontSize = 38,
  noBorder,
  sx
}) => {
  return (
    <ProviderIcon
      size={iconSize}
      sx={{ fontSize, fontWeight: 'bold', ...sx }}
      noBorder={noBorder}
      {...buildProviderImageProps({ provider, isForceBrandIcon })}
    />
  )
}

export default memo(ExchangeProviderIcon)
